#import "../nut-email-address-fragment.graphql"
#import "../related-lead-fragment.graphql"

fragment EmailFragmentFull on Email {
    id
    subject
    bodyExcerpt
    # Alias because bodyHtml type for Email is !String which conflicts with type Note's bodyHtml type String
    emailBodyHtml: bodyHtml
    attachments {
        fileId
        name
        href
        fileType
    }
    isShared
    isShareable
    isAutomatedReply
    isEmailAutomation
    isTicketMessage
    ticketId
    ticketUrl
    trackedViewsCount
    trackedClicksCount
    recipients {
        ...NutEmailAddressFragment
    }
    from {
        ...NutEmailAddressFragment
    }
    isInbound
    isOutbound
    isFailed
    isReplyable
    isNutshellMarketingEmail
    htmlUrl
    htmlUrlPath
    edition {
        id
        name
    }
    # Alias because types differ for Activities and Emails
    emailRelatedLeads: relatedLeads {
        edges {
            isMapped
            node {
                ...RelatedLeadFragment
            }
        }
    }
    originatedVia
    sentWithinLastWeek
    hasAcceptedSuggestion
}
